import { Box, Button } from '@factorialco/deprecated-design-system'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

type Props = {
  onChange: (feedback: string | undefined) => void
  onSubmit: () => void
  currentValue: string | undefined
  isSubmitting: boolean
}

const Feedback = ({ currentValue, onChange, onSubmit, isSubmitting }: Props) => {
  return (
    <Box alignItems="flexEnd" gap="s24">
      <TextArea
        placeholder={i18n.t('nps.feedback.placeholder')}
        value={String(currentValue || '')}
        maxLength={250}
        onChange={onChange}
      />
      <Button onClick={() => onSubmit()} loading={isSubmitting}>
        {i18n.t('nps.feedback.submit')}
      </Button>
    </Box>
  )
}

export default Feedback
